<template>
  <filtertron-tray-section
    v-if="tab.type !== 'Details'"
    id="tab-configurator-categories"
    :title="lang.get('tabs.form.categories.text')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <category-config
        :resource="tab"
        :categories="categories"
        :placeholder="lang.get('tabs.form.categories.placeholder')"
        :all-categories-label="lang.get('tabs.form.categories_all.label')"
        :select-categories-label="lang.get('tabs.form.categories_select.label')"
        @input="config => $emit('input', config)"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import CategoryConfig from '@/lib/components/Categories/CategoryConfig';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    CategoryConfig,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['categories'])
  }
};
</script>
